module.exports = __webpack_public_path__ + "static/media/Test22.efe44059.bmp";